<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      class="form-inline query-builder"
      wrap>
      <v-flex md12>

        <div class="rules-group-container"> 
            <div class="rules-group-header">
                <v-form ref="form" v-model="validForm">
                <div class="btn-group pull-right group-actions"> 
                </div>
                
                  <v-layout>
                      <v-flex xs12 sm2 md2 >
                        <v-autocomplete
                          md4
                          clearable
                          :search-input.sync="protocolSearchString"
                          v-model="item.protocol_id"
                          :items="protocols"
                          color="primary"
                          hide-no-data
                          item-text="name"
                          item-value="id"
                          label="Protocol"
                          prepend-icon="mdi-database-search"
                          :loading="loadingProtocols"
                          :disabled="!isNew">
                        </v-autocomplete>
                      </v-flex>

                      <v-flex xs12 sm3 md3>
                        <v-text-field
                          label="Name"
                          v-model="item.name"
                        ></v-text-field>
                    </v-flex>

                      <v-flex xs12 sm2 md2>
                        <v-select
                              clearable
                              md4
                              v-model="item.status"
                              :items="['Open', 'Close', 'Warning']"
                              label="Status"
                              :disabled="isNew"
                            ></v-select>
                      </v-flex>



                    <v-flex xs12 sm1 md1>

                      <v-menu
                        ref="menu"
                        v-model="monthPicker"
                        :close-on-content-click="false"
                        :return-value.sync="item.three.start_month"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="item.three.start_month"
                            label="Start month"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="item.three.start_month"
                          type="month"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="monthPicker = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu.save(item.three.start_month)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>

                    </v-flex>



                    <v-flex xs12 sm1 md1>
                        <v-text-field
                          label="Accrual"
                          v-model="item.three.enrollment_duration"
                        ></v-text-field>
                    </v-flex>

                    <v-flex xs6 sm1 md1>
                      <v-btn small color="primary" v-if="!isNew" :disabled="!item.three.start_month || !item.three.enrollment_duration"  @click="editPatients">Patients</v-btn>
                    </v-flex>

                    <v-flex xs6 sm1 md1>
                      <v-btn small color="primary" v-if="!isNew" :disabled="isDownloading || !item.three.start_month || !item.three.enrollment_duration"  @click="calculate"><v-icon>mdi-file-excel</v-icon> Calculate</v-btn>
                    </v-flex>

                </v-layout>
              </v-form>
            </div>


            <div class="rules-group-body"> 
              <div class="rules-list">
                <component
                  v-for="(child, index) in item.three.children"
                  :key="index"
                  :is="child.type"
                  :type="child.type"
                  :three.sync="child.three"
                  :index="index"
                  :maxDepth="maxDepth"
                  :depth="depth + 1"
                  :drugs="drugs"
                  v-on:child-deletion-requested="removeChild">
                </component>
              </div>
            </div>

            <v-flex xs12 sm12 md12 text-right>
              <v-btn small color="primary" v-if="!isNew" @click="addTimepoint">Add Timepoint</v-btn>
            </v-flex>

            <app-patients-countries-modal 
              v-model="openPatientsCountries" 
              :totalMonths="totalMonths" 
              :startMonth="item.three.start_month"
              :timepointMonths="timepointMonths" 
              :patients.sync="item.three.patients" />

        </div>

      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>

const { upsert, getDetail, getList } = require('@/api/base_entity')
const { getEstimateExcel } = require('@/api/estimate')

import TimepointGroup from "@/components/threeBuilder/components/TimepointGroup.vue";

export default {
  components: {
    TimepointGroup
  },
  data () {
    return { 
      validForm: true,
      protocolSearchString: "",
      loadingProtocols: false,
      protocols: [],
      drugs: [],
      choosedProtocol: null,
      protocol_id: null,
      openPatientsCountries: false,
      isDownloading: false,
      monthPicker:false,
      maxDepth: 3,
      depth: 1,
      item: {
        id: null,
        three: {
          children: []
        },
      },
      rules: [],
    }
  },
  watch: {
    protocolSearchString(val) {
      if (!val) {
        this.protocols = [];
        return;
      }
      this.loadingProtocols = true;
      getList('protocol', { "name":  "%" + val + "%"}, { rowsPerPage: null }).then(data => {
        this.protocols = data.data;
        this.loadingProtocols = false;
      });
    },
    // three: {
    //   handler() {
    //     this.save(false)
    //   },
    //   deep: true
    // }
     item: {
        handler(val, oldVal) {
          
          if ((val.protocol_id && !this.item.three.children.length) || (val.protocol_id != oldVal.protocol_id)) {
            getList('drug', { "protocol_id":  this.item.protocol_id}, { rowsPerPage: null }).then(data => {
              
              let drugs_k = {}
              data.data.forEach( el => {
                
                if(drugs_k[el['name']]) {
                  if(drugs_k[el['name']]['doses']) {
                    drugs_k[el['name']]['doses'].push(Number(el['dose']))
                  } else {
                    drugs_k[el['name']]['doses'] = [Number(el['dose'])];
                  }
                } else {
                  drugs_k[el['name']] = { doses: [Number(el['dose'])]};
                }

              })
              this.drugs = drugs_k

            });
            getList('protocol', { "id":  this.item.protocol_id}, { rowsPerPage: null }).then(data => {
              this.protocols = data.data;
            });
        }
        this.save(false);
      },
      deep: true
    }
  },
  created() {
    if (this.$route.params.estimate_id) {
      getDetail('estimate', {id:this.$route.params.estimate_id}).then( data => {
        if(!data.three.patients || Array.isArray(data.three.patients)) {
          data.three.patients = {};
        }
        this.item = data;
      })
    } 
  },
  computed: {
    isNew() {
      return this.item.id ? false : true;
    },
    totalMonths() {
      return parseInt(this.item.three.enrollment_duration);
    },
    timepointMonths() {
      const ret = {};
      let a = 1;
      this.item.three.children.map( el => {
        for(let i = 1;i<=el.three.cycles;i++) {
          ret[a++] = el.three.name;
        }
      })
      return ret;
    }
  },
  methods: {
     addTimepoint() {
      if (this.depth < this.maxDepth) {
        this.item.three.children.push({
          type: "timepoint-group",
          three: {
            children: []
          }
        });
        this.$emit("update:three", this.three);
      }
    },

    remove() {
      this.$emit("child-deletion-requested", this.index);
    },

    removeChild(index) {
      this.item.three.children.splice(index, 1);
      this.$emit("update:three", this.three);
    },
    editPatients() {
      this.openPatientsCountries = true;
    },
    save(notify = true) {

      this.item.status = this.item.status ? this.item.status : 'Open';
      this.item.account_id = this.$store.getters.user.account_id;

      upsert('estimate', this.item).then( (d) => {
          this.item.id = d.assetId;
          if (notify) {
            this.$root.$emit('openSnackbar', {
              message: ' Updated correctly',
              color: 'success'
            })
          }
      });
    },
    calculate() {
      this.isDownloading = true;
      getEstimateExcel(this.item.id).then( () => {
        this.$root.$emit('openSnackbar', {
          message: ' Estimate downloaded correctly',
          color: 'success'
        })
      }).catch( e => {
         this.$root.$emit('openSnackbar', {
          message: ' Estimate downloaded error : ' + e.message,
          color: 'error'
        })
      }).finally( () => {
        this.isDownloading = false;
      })
    }
  },
  editPatients() {
      this.openPatientsCountries = true;
    },
    calculate() {
      this.isDownloading = true;
      getEstimateExcel(this.three.id).then( () => {
        this.$root.$emit('openSnackbar', {
          message: ' Estimate downloaded correctly',
          color: 'success'
        })
      }).catch( e => {
         this.$root.$emit('openSnackbar', {
          message: ' Estimate downloaded error : ' + e.message,
          color: 'error'
        })
      }).finally( () => {
        this.isDownloading = false;
      })
    }
}
</script>



<style>
/*!
 * jQuery QueryBuilder 2.5.2
 * Copyright 2014-2018 Damien "Mistic" Sorel (http://www.strangeplanet.fr)
 * Licensed under MIT (https://opensource.org/licenses/MIT)
 */
.query-builder .rule-container,
.query-builder .rule-placeholder,
.query-builder .rules-group-container {
  position: relative;
  margin: 4px 0;
  border-radius: 5px;
  padding: 5px;
  border: 1px solid #eee;
  background: rgba(255, 255, 255, 1);
  box-shadow: 1px 1px 5px 1px #c0a7a7;
}

.query-builder .timepoint-group-container {
  position: relative;
  margin: 4px 0;
  border-radius: 5px;
  padding: 5px;
  border: 1px solid #ffbcbc;
  background: rgba(255, 226, 226, 1);
  box-shadow: 1px 1px 5px 1px #c0a7a7;
}

.query-builder .drag-handle,
.query-builder .error-container,
.query-builder .rule-container .rule-filter-container,
.query-builder .rule-container .rule-operator-container,
.query-builder .rule-container .rule-value-container {
  display: inline-block;
  margin: 0 5px 0 0;
  vertical-align: middle;
}

.query-builder .rules-group-container {
  padding: 10px;
  padding-bottom: 6px;
  border: 1px solid #dcc896;
  background: rgba(250, 240, 210, 0.5);
}

.query-builder .rules-group-header {
  margin-bottom: 10px;
}

.query-builder .rules-group-header .group-conditions .btn.readonly:not(.active),
.query-builder .rules-group-header .group-conditions input[name$="_cond"] {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
}

.query-builder .rules-group-header .group-conditions .btn.readonly {
  border-radius: 3px;
}

.query-builder .rules-list {
  list-style: none;
  padding: 0 0 0 15px;
  margin: 0;
}

.query-builder .rule-value-container {
  border-left: 1px solid #ddd;
  padding-left: 5px;
  width:300px;
}

.query-builder .rule-value-container label {
  margin-bottom: 0;
  font-weight: 400;
}

.query-builder .rule-value-container label.block {
  display: block;
}

.query-builder .error-container {
  display: none;
  cursor: help;
  color: red;
}

.query-builder .has-error {
  background-color: #fdd;
  border-color: #f99;
}

.query-builder .has-error .error-container {
  display: inline-block !important;
}

.query-builder .rules-list > ::after,
.query-builder .rules-list > ::before {
  content: "";
  position: absolute;
  left: -10px;
  width: 10px;
  height: calc(50% + 4px);
  border-color: #ccc;
  border-style: solid;
}

.query-builder .rules-list > ::before {
  top: -4px;
  border-width: 0 0 2px 2px;
}

.query-builder .rules-list > ::after {
  top: 50%;
  border-width: 0 0 0 2px;
}

.query-builder .rules-list > :first-child::before {
  top: -12px;
  height: calc(50% + 14px);
}

.query-builder .rules-list > :last-child::before {
  border-radius: 0 0 0 4px;
}

.query-builder .rules-list > :last-child::after {
  display: none;
}

.query-builder.bt-checkbox-glyphicons
  .checkbox
  input[type="checkbox"]:checked
  + label::after {
  font-family: "Glyphicons Halflings";
  content: "\e013";
}

.query-builder.bt-checkbox-glyphicons .checkbox label::after {
  padding-left: 4px;
  padding-top: 2px;
  font-size: 9px;
}

.query-builder .error-container + .tooltip .tooltip-inner {
  color: #f99 !important;
}

.query-builder p.filter-description {
  margin: 5px 0 0 0;
  background: #d9edf7;
  border: 1px solid #bce8f1;
  color: #31708f;
  border-radius: 5px;
  padding: 2.5px 5px;
  font-size: 0.8em;
}

.query-builder .rules-group-header [data-invert] {
  margin-left: 5px;
}

.query-builder .drag-handle {
  cursor: move;
  vertical-align: middle;
  margin-left: 5px;
}

.query-builder .dragging {
  position: fixed;
  opacity: 0.5;
  z-index: 100;
}

.query-builder .dragging::after,
.query-builder .dragging::before {
  display: none;
}

.query-builder .rule-placeholder {
  border: 1px dashed #bbb;
  opacity: 0.7;
}
.pull-right {
  float: right !important;
}
.has-error {
  background-color: #fdd;
  border-color: #f99;
}
</style>